import { PrimaryButton } from 'src/shared/design-system/Buttons';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css, keyframes } from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing, ZIndex } from 'web-common/src/shared/styles';
import { INPUT_LABELS } from './consts';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Form = styled.div`
  display: grid;
  grid-template-columns: calc(50% - ${Spacing.HALF}) calc(50% - ${Spacing.HALF});
  grid-template-rows: auto;
  gap: ${Spacing.SINGLE_QUARTER} ${Spacing.SINGLE};
  font-family: ${Font.Family.BODY_SANS};
`;

export const InputLabel = styled.div`
  color: ${Colors.GRAY_DARK_20};
  margin-bottom: ${Spacing.QUARTER};
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
  ${Font.bySize(Font.Size.XXS)};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  & input::placeholder {
    color: ${Colors.GRAY_DARK_10};
  }
`;

export const ValueContainer = styled.div<{ isPopupEnabled?: boolean }>`
  display: flex;
  gap: ${Spacing.QUARTER};
  position: relative;

  ${ifProp(
    'isPopupEnabled',
    css`
      & [data-role='dropdown-menu'] {
        top: 94px !important;
        left: 32px !important;
      }
    `
  )};

  & > div:first-child {
    max-width: 60px;

    & > div {
      height: 100%;
    }

    & [data-role='dropdown-arrow'] {
      width: ${Spacing.THREE_QUARTERS};
      box-sizing: content-box;
    }
  }

  & [data-selected='true'] {
    & > div:last-child {
      position: absolute;
      padding: 0;
      right: ${Spacing.HALF};

      & svg {
        transform: scale(0.7);
      }
    }
  }

  & input {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
  }
`;

export const ValueInputWrapper = styled.div<{ hasValue?: boolean }>`
  display: flex;
  position: relative;

  &:after {
    align-items: center;
    content: '$';
    color: ${ifProp('hasValue', Colors.GRAY_DARK_30, Colors.GRAY_DARK_10)};
    display: flex;
    position: absolute;
    height: 100%;
    top: -1px;
    left: ${Spacing.SINGLE};
  }

  & > input {
    flex: 1 1 auto;
    padding-left: ${Spacing.SINGLE_HALF};
    width: 100%;
  }
`;

export const CreateButton = styled(PrimaryButton.M.RED).attrs(() => ({
  children: INPUT_LABELS.CREATE_BUTTON,
}))`
  margin-top: ${Spacing.SINGLE};
`;

export const Note = styled.div`
  color: ${Colors.GRAY_DARK_20};
  margin-top: ${Spacing.SINGLE};
  text-align: center;
  ${Font.bySize(Font.Size.S)};
`;

export const PromoCodeTextContainer = styled.div`
  color: ${Colors.WHITE};
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.SINGLE};
  text-align: center;
`;

export const PromoCodeText = styled.div`
  background: ${Colors.RADISH};
  border-radius: ${Spacing.DOUBLE};
  padding: ${Spacing.HALF} ${Spacing.THREE_QUARTERS};
`;

export const PromoCodeValue = styled.span`
  font-weight: ${Font.Weight.SEMI_BOLD};
`;

export const PopupContainer = styled.div`
  background: ${Colors.WHITE};
  border-radius: ${Border.Radius.M};
  box-shadow: 0 ${Spacing.EIGHTH} ${Spacing.QUARTER} rgba(0, 0, 0, 0.25);
  margin: 0 ${Spacing.HALF};
  max-width: 460px;
  padding: ${Spacing.SINGLE};

  ${Mixins.Media.maxWidthSmall(css`
    max-width: calc(100vw - ${Spacing.DOUBLE});
  `)}
`;

export const PopupChildrenWrapper = styled.div`
  display: inherit;
`;

export const PopupBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: ${ZIndex.Modal};

  animation: ${fadeIn} 0.3s both;
`;
